module.exports = __webpack_public_path__ + "media/cash.edefca89.mp3";